import { computed } from 'vue';

import type { EntityQueryReturn } from '../query/types';
import type { DataPayload, DataSource } from './types';

type UseQueryDataSourceOptions<TLoad extends DataPayload> = Readonly<{
  query: EntityQueryReturn<TLoad>;
}>;

/**
 * Bare data-source wrapper. Projects a TanStack Query handle into the
 * `DataSource<TLoad>` shape. Used by pages that combine raw entity load
 * with form submit (TargetGroup) or are read-only (Summary).
 */
export const useQueryDataSource = <TLoad extends DataPayload>(
  options: UseQueryDataSourceOptions<TLoad>,
): DataSource<TLoad> => {
  const { query } = options;

  const data = computed(() => query.data.value ?? null);

  const reload = async (): Promise<void> => {
    await query.refetch();
  };

  return {
    state: {
      isLoading: query.isLoading,
      data,
      loadError: query.error,
    },
    actions: { reload },
  };
};
